var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_622_6898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.50217 17C3.81535 17 0 13.189 0 8.50217C0 3.81535 3.81535 0 8.50217 0C13.189 0 17.0043 3.81102 17.0043 8.50217C17.0043 13.1933 13.189 17.0043 8.50217 17.0043V17ZM8.50217 1.30069C4.53073 1.30069 1.30069 4.53073 1.30069 8.50217C1.30069 12.4736 4.53073 15.7036 8.50217 15.7036C12.4736 15.7036 15.7036 12.4736 15.7036 8.50217C15.7036 4.53073 12.4693 1.30069 8.50217 1.30069Z",
    fill: "#2248C1",
    className: "fill-selector"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.34771 6.30398V12.9982H7.60912V7.5353H6.63794V6.30832H9.35204L9.34771 6.30398ZM8.47625 3.39911C9.00086 3.39911 9.43442 3.83267 9.43442 4.35728C9.43442 4.88189 9.00086 5.30245 8.47625 5.30245C7.95163 5.30245 7.53108 4.88189 7.53108 4.35728C7.53108 3.83267 7.95163 3.39911 8.47625 3.39911Z",
    fill: "#2248C1",
    className: "fill-selector"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_622_6898"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    className: "fill-selector"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.3161c08d53ec6513d7059087a30291ac.svg";
export { ForwardRef as ReactComponent };